const lead = {
    computed: {
        lead: {
            get() {
                return this.$store.state.lead.lead
            },
            set(payload) {
                this.$store.commit('lead/setLead', payload)
            }
        }
    },
    methods: {
        validate() {
            var errors = [];
            var state = this.$store.state.lead;
            Object.keys(state.validation).forEach(ruleKey => {
                if (!state.validation[ruleKey].method(state.lead[ruleKey])) {
                    errors.push(state.validation[ruleKey].message)
                }
            });
            this.$store.commit('lead/setErrors', errors);
        },
        getDayofWeek(date) {
            var r = new Date(Date.parse(date));
            console.log(r.getDay());
            return r.getDay();
        },
        pushService(service) {
            let id = this.lead.services_val.indexOf(service.val);
            if (id != -1) {
                this.lead.services_val.splice(id, 1);
            } else {
                this.lead.services_val.push(service.val)
            }
        }
    },
    watch: {
        lead: {
            handler() {
                this.validate()
            },
            deep: true
        }
    },
    mounted() {
        this.validate()
    }
}

export default lead;